module.exports = __webpack_public_path__ + "static/media/Leopard_Header.0ec3f44f.png";